import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import Location, { LocationDto } from "./Location"
import { LocationTemplatesPayload } from "./LocationPayload"

class LocationService {
    static httpClient = new HttpClient<Location, LocationDto>(Location)

    static async getLocationById(id: string): Promise<Location> {
        const res = await this.httpClient.get(`/locations/${id}`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as Location
    }

    static async update(id: string, payload: LocationTemplatesPayload): Promise<HttpError | Location> {
        const res = await this.httpClient.patch(`/locations/${id}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Location
    }

    static async fetchAllLocations(includeArchived?: boolean): Promise<Location[]> {
        const query = new URLSearchParams()
        if (includeArchived) {
            query.append("includeArchived", "true")
        }

        const url = `/locations?${query.toString()}`
        
        const res =  await this.httpClient.get(url)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as Location[]
    }

}

export default LocationService



// WEBPACK FOOTER //
// ./src/state/location/LocationService.ts